<template>
    <section id="master-share-quiz" class="layout">
        <div class="header pb-3">
            <div class="mx-auto">
                <HeaderLogo logo-width="12" color="var(--ui-color)" shadow="var(--question-shadow-color)"></HeaderLogo>
            </div>
        </div>
        <div class="content xl:flex xl:items-center">
            <div class="content-container relative mx-auto h-full">
                <div class="box">
                    <div class="mb-4 xl:mb-10 text-center text-white">
                        <h1
                            class="theme-question-text-color theme-question-shadow font-size-18 md:font-size-38 mb-2 mt-0 mb-3 text-center"
                        >
                            {{ title }}
                        </h1>
                        <div style="padding: 0px 8.706%">
                            <div
                                @click.prevent="copyShareLink"
                                class="quiz-detail-container inline-block mx-auto cursor-pointer"
                            >
                                <div class="flip-qrcode mx-auto cursor-pointer">
                                    <div class="flip-qrcode-inner">
                                        <div
                                            class="flip-qrcode-front"
                                            :style="`background-image: url(${
                                                image ? image : getQuizImage(quiz, true)
                                            }); background-color: ${
                                                quiz.theme_name
                                                    ? quiz.themes[quiz.theme_name].background_color
                                                    : backgroundColor
                                            }`"
                                        ></div>
                                        <div class="flip-qrcode-back">
                                            <qrcanvas
                                                :class="{
                                                    'qrcode w-full h-full rounded border-8 border-solid border-white': true,
                                                    show: isShowQrCode
                                                }"
                                                :options="qrCodeOptions"
                                            ></qrcanvas>
                                        </div>
                                    </div>
                                </div>
                                <a class="flex-1 flex flex-col items-center no-underline">
                                    <p
                                        class="text-black shadow-text-none font-size-16 md:font-size-18 xl:font-size-22 font-bold"
                                    >
                                        {{ baseUrl.replace('http://', '').replace('https://', '') }}join
                                    </p>
                                    <p
                                        class="text-black shadow-text-none font-size-24 md:font-size-30 xl:font-size-34 font-bold text-5xl leading-none"
                                    >
                                        {{ code }}
                                    </p>
                                </a>
                            </div>
                        </div>
                        <p
                            class="theme-question-text-color theme-question-shadow font-bold font-size-18 md:font-size-26 break-words"
                        >
                            {{ customMessage }}
                        </p>
                    </div>
                    <div class="theme-question-text-color text-center text-white">
                        <p class="theme-question-shadow font-bold font-size-26 xl:font-size-30 uppercase">
                            {{ users.length }} <span v-if="limitPlayer"></span> {{ $t('playlive_share_joined') }}
                        </p>
                    </div>
                </div>

                <div class="box">
                    <div class="relative py-2 md:py-0 w-full h-full">
                        <!-- Begin list Mobile -->
                        <div class="mobile text-center">
                            <ul class="list-reset my-0 md:mt-4 overflow-y-auto" v-if="users.length > 0">
                                <template v-for="(user, userIndex) in users">
                                    <li
                                        :class="{
                                            'theme-ui-text-color text-white font-bold uppercase font-size-22 md:inline-block': true,
                                            'md:mr-4': users.length > 1
                                        }"
                                        :key="user.id"
                                        v-if="userIndex < 6"
                                    >
                                        <span class="theme-question-shadow">{{ user }}</span>
                                    </li>
                                </template>
                                <li class="text-white font-bold uppercase font-size-22 md:mt-1" v-if="users.length > 6">
                                    <div
                                        class="theme-ui-text-color theme-question-shadow text-white inline-block underline"
                                        @click="isShowMorePlayerPopup = true"
                                    >
                                        {{ users.length - 6 }} {{ $t('playlive_share_more') }}
                                    </div>
                                </li>
                            </ul>
                            <ul v-else class="list-reset my-0 overflow-y-auto opacity-0">
                                <li
                                    class="theme-ui-text-color text-white font-bold uppercase font-size-22"
                                    :key="`mock-list-${n}`"
                                    v-for="n in 7"
                                >
                                    <span class="theme-question-shadow">{{ n }}</span>
                                </li>
                            </ul>
                        </div>
                        <!-- End list Mobile -->

                        <!-- Begin list Desktop -->
                        <div class="desktop w-full h-full py-3 pl-10">
                            <ul class="list-reset overflow-x-auto whitespace-no-wrap w-full h-full m-0">
                                <li
                                    v-for="user in users"
                                    class="theme-ui-text-color mb-4 text-white uppercase font-size-28"
                                    :key="user.id"
                                >
                                    <span class="theme-question-shadow">{{ user }}</span>
                                </li>
                            </ul>
                        </div>
                        <!-- End list Desktop -->
                    </div>
                </div>
            </div>
        </div>
        <div class="footer">
            <div class="flex md:hidden items-center flex-col justify-center w-full h-full">
                <p class="theme-ui-text-color theme-question-shadow text-white font-3xl font-bold">{{ baseUrl }}join</p>
                <p
                    class="theme-ui-text-color theme-question-shadow text-white font-4xl font-garage font-bold text-5xl mb-4"
                >
                    {{ code }}
                </p>
            </div>

            <DesktopFooter>
                <template slot="left">
                    <div class="flex items-end h-12">
                        <a
                            class="theme-ui-text-color cursor-pointer text-white font-size-18 uppercase flex items-center font-bold"
                            @click="toggleFullScreen"
                            type="button"
                        >
                            <i
                                v-if="isFullscreen"
                                class="theme-question-shadow fas fa-compress-arrows-alt font-size-22 mr-1"
                            ></i>
                            <i
                                v-if="!isFullscreen"
                                class="theme-question-shadow fas fa-expand-arrows-alt font-size-22 mr-1"
                            ></i>
                        </a>
                    </div>
                </template>
            </DesktopFooter>
        </div>
        <SeeMorePlayerPopup v-if="isShowMorePlayerPopup" :players="users" @close="isShowMorePlayerPopup = false" />
    </section>
</template>

<script>
import { mapState } from 'vuex'
import appConfig from '@/app.config.js'
import HeaderLogo from '@/components/HeaderLogo.vue'
// import popup from '@/lib/popup.js'
import Background from '@/lib/background.js'
import DesktopFooter from '@/components/DesktopFooter.vue'
import FullScreen from '@/lib/fullscreen.js'
import SeeMorePlayerPopup from '@/components/SeeMorePlayerPopup.vue'
import preloadImageMixin from '@/mixins/preload-image'
import preloadSongMixin from '@/mixins/preload-song'
import helperMixins from '@/mixins/helper.js'
import helperLiveQuiz from '@/mixins/helper-live-quiz.js'
import Qrcanvas from 'qrcanvas-vue'
import popup from '@/lib/popup.js'
import { currentUser } from '@/lib/user'

export default {
    components: {
        HeaderLogo,
        DesktopFooter,
        SeeMorePlayerPopup,
        Qrcanvas
    },

    mixins: [preloadImageMixin, preloadSongMixin, helperMixins, helperLiveQuiz],

    sockets: {
        master_pressed_start: function () {
            this.$store.dispatch('player/handleNextQuestionIndex')
            this.$router.push({
                name: 'live-result'
            })
        },

        user_joined_waiting_count: function (users) {
            this.users = users.reverse()

            if (this.users.length) {
                if (!this.playBoxAnimation) {
                    const leftBox = document.querySelectorAll('.box')[0]
                    const rightBox = document.querySelectorAll('.box')[1]

                    leftBox.style.transform = `translate(calc(-50% - (${leftBox.offsetWidth}px / 2) - 40px), -50%)`
                    rightBox.style.transform = `translate(calc(50% + (${rightBox.offsetWidth}px / 2) + 40px), -50%) scale(.9)`

                    setTimeout(() => {
                        rightBox.style.opacity = 1
                        rightBox.style.filter = 'blur(0px)'
                        rightBox.style.transform = `translate(calc(50% + (${rightBox.offsetWidth}px / 2) + 40px), -50%) scale(1)`
                    }, 500)

                    this.playBoxAnimation = true
                }

                // var clone = this.audioDifinite.cloneNode()
                // if (this.masterSound.effectMusic) {
                //     clone.play()
                // }

                // if (helper.iOS()) {
                //     if (this.masterSound.effectMusic) {
                //         this.audioDifinite.play()
                //     }
                // }
            }
        },

        master_ended_game: function () {
            window.location.href = '/join'
        },

        user_ended_game: function (data) {
            this.$store.commit('updatePlayerCount', data.users.length)
            this.users = data.users

            if (!this.users.length) {
                const leftBox = document.querySelectorAll('.box')[0]
                const rightBox = document.querySelectorAll('.box')[1]

                rightBox.style.opacity = 0
                rightBox.style.filter = 'blur(2px)'
                rightBox.style.transform = `translate(calc(50% + (${rightBox.offsetWidth}px / 2) + 40px), -50%) scale(.9)`
                leftBox.style.transform = `translate(-50%, -50%)`

                this.playBoxAnimation = false
            }
        },

        master_send_user_limit: function (data) {
            this.limitPlayer = data.limit_player
        }
    },

    created() {
        this.addStyleSheet(this.code)
        this.$store.commit('updateQrCodeUrl', this.code)
        this.isShowQrCode = true
    },

    mounted: function () {
        this.$socket.emit('user_joined_waiting', {
            room: this.code
        })

        new Background({
            color: this.quiz.theme_name
                ? this.quiz.themes[this.quiz.theme_name].background_color
                : this.backgroundColor,
            image: this.quiz.theme_name
                ? this.quiz.themes[this.quiz.theme_name].background_image
                : this.backgroundImage,
            type: this.backgroundType,
            blur: this.blur,
            darken: this.darken,
            navText: this.frontPageSetting.nav_text,
            useTheme: this.quiz.theme_name ? true : false
        })

        this.rotateQrCode()

        if (!this.isLived) {
            popup.alert(this.$t('playlive_alert_secondary_screen'), () => {
                this.$store.commit('updateLiveStatus')
            })
        }

        // Receive custom event componentAlready
        window.addEventListener('componentAlready', () => {
            if (this.$route.name === 'live-share') {
                this.resizeScaleQuizFrame()
            }
        })
    },

    data: function () {
        return {
            baseUrl: appConfig.shortBaseUrl,
            users: [],
            fullscreen: new FullScreen('.app-wrapper'),
            limitPlayer: 0,
            isFullscreen: false,
            isShowMorePlayerPopup: false,
            playBoxAnimation: false,
            isShowQrCode: false,
            rotate: 0,
            times: 1300
        }
    },

    computed: mapState({
        id: state => state.player.quiz._id,
        quiz: state => state.player.quiz,
        title: state => state.player.quiz.title,
        code: state => state.player.quiz.code,
        type: state => state.question.type,
        description: state => state.player.quiz.description,
        image: state => state.player.quiz.image,
        backgroundImage: state => state.player.quiz.background_image,
        blur: state => state.player.quiz.background_image_blur,
        darken: state => state.player.quiz.background_image_darken,
        backgroundColor: state => state.player.quiz.background_color,
        backgroundType: state => state.player.quiz.background_type,
        frontPageSetting: state => state.frontPageSetting,
        customMessage: state => state.question.custom_message,
        qrCodeOptions: state => state.qrCodeOptions,
        isLived: state => state.isLived
    }),

    methods: {
        rotateQrCode() {
            setTimeout(() => {
                const rotateElement = document.querySelector('.flip-qrcode-inner')

                if (!rotateElement) return

                rotateElement.animate(
                    [{ transform: `rotateY(${this.rotate}deg)` }, { transform: `rotateY(${this.rotate - 180}deg)` }],
                    {
                        iterations: 1,
                        fill: 'forwards',
                        easing: 'ease',
                        duration: 1300
                    }
                )

                this.rotate -= 180

                if (this.times === 1300 || this.times === 300) {
                    this.times = 5000 + 1300
                } else if (this.times === 5000) {
                    this.times = 3000 + 1300
                }

                this.rotateQrCode()
            }, this.times)
        },

        copyShareLink() {
            // If browser support native share link
            if (window.navigator.share) {
                navigator
                    .share({
                        title: 'TheBigQuiz',
                        text: `Join ${this.title} - TheBigQuiz`,
                        url: this.shareLink()
                    })
                    .then(() => {})
            } else {
                navigator.clipboard
                    .writeText(this.shareLink())
                    .then(() => {
                        popup.alert(this.$t('playlive_share_alert_link_copied'), () => {}, {
                            icon: 'success'
                        })
                    })
                    .catch(() => {
                        popup.alert(this.$t('playlive_share_alert_link_copied_error'), () => {}, {
                            icon: 'error'
                        })
                    })
            }
        },

        shareLink() {
            if (currentUser().share_code) {
                let shareCode = currentUser().share_code

                return `${appConfig.shortBaseUrl}join/${this.code}/share?u=${shareCode}`
            }

            return `${appConfig.shortBaseUrl}join/${this.code}/share`
        }
    }
}
</script>

<style lang="scss">
#master-share-quiz {
    height: calc((var(--vh, 1vh) * 100) - 2rem);

    .header div {
        @media screen and (max-width: 767px) {
            max-width: 9rem !important;
        }
    }

    .content {
        @media screen and (max-width: 1920px) {
            overflow: hidden;
            height: calc(100% - var(--useless-h));
        }

        .content-container {
            width: 100%;
            min-height: 700px;
            column-gap: 40px;
            transform-origin: unset !important;

            @media screen and (max-width: 1199px) and (orientation: portrait), (max-width: 767px) {
                max-width: 50rem;
                height: auto;
                display: block;
            }

            @media screen and (max-width: 1199px) {
                transform-origin: center top !important;
            }

            @media screen and (max-width: 767px) {
                min-height: 818px;
            }

            .box {
                position: absolute;
                top: 50%;
                width: auto;
                height: 90%;
                aspect-ratio: 2 / 3;
                padding: 2.12% 1.49%;
                background-color: rgba(0, 0, 0, 0.3);
                border-radius: 3.3%/2.6%;
                overflow: hidden;

                @media screen and (max-width: 1199px) and (orientation: portrait), (max-width: 767px) {
                    position: unset;
                    width: auto;
                    height: auto;
                    aspect-ratio: unset;
                    margin: 0 auto;
                    padding: 0;
                    background-color: unset;
                    border-radius: 1rem;
                }

                &:first-of-type {
                    left: 50%;
                    transform: translate(-50%, -50%);
                    transition: transform 0.5s ease;

                    @media screen and (max-width: 1199px) and (orientation: portrait), (max-width: 767px) {
                        position: unset !important;
                        transform: unset !important;
                    }
                }

                &:last-of-type {
                    right: 50%;
                    transform: translate(calc(50% + 250px + 40px), -50%) scale(0.9);
                    opacity: 0;
                    filter: blur(2px);
                    transition: opacity 0.5s ease, filter 0.5s ease, transform 0.5s ease;

                    @media screen and (max-width: 1199px) and (orientation: portrait), (max-width: 767px) {
                        position: unset !important;
                        transform: unset !important;
                    }

                    .mobile {
                        display: none;

                        @media screen and (max-width: 1199px) and (orientation: portrait), (max-width: 767px) {
                            display: block;
                        }
                    }

                    .desktop {
                        display: block;

                        @media screen and (max-width: 1199px) and (orientation: portrait), (max-width: 767px) {
                            display: none;
                        }
                    }
                }

                h1 {
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    word-break: break-word;
                }

                ul {
                    &::-webkit-scrollbar {
                        width: 10px;
                    }

                    &::-webkit-scrollbar-thumb {
                        border-radius: 10px;
                        background-color: rgba(255, 255, 255, 0.2);
                    }
                }

                .quiz-detail-container {
                    width: 100%;
                    background-color: white;
                    border-radius: 3%;
                    padding: 4.22% 5.274%;

                    @media screen and (max-width: 1199px) and (orientation: portrait) {
                        width: auto;
                        padding: 0.5rem 0.75rem 0.75rem 0.75rem;
                        border-radius: 0.75rem;
                    }

                    .flip-qrcode {
                        perspective: 1000px;
                        aspect-ratio: 1 / 1;
                        width: 100% !important;
                        height: auto !important;

                        @media screen and (max-width: 1199px) and (orientation: portrait) {
                            width: 16rem !important;
                        }

                        @media screen and (max-width: 767px) {
                            width: 12rem !important;
                        }

                        .flip-qrcode-inner {
                            position: relative;
                            width: 100%;
                            height: 100%;
                            text-align: center;
                            transform-style: preserve-3d;
                            border-radius: 0.75rem;
                            background-size: cover;
                            background-position: center;

                            .flip-qrcode-front,
                            .flip-qrcode-back {
                                position: absolute;
                                width: 100% !important;
                                height: 100% !important;
                                top: 50%;
                                left: 50%;
                                transform: translate(-50%, -50%);
                                -webkit-backface-visibility: hidden;
                                backface-visibility: hidden;
                            }

                            .flip-qrcode-front {
                                border-radius: 2%;
                                background-color: var(--legacy-text-color);
                                background-image: url('../assets/bg-back-qrcode.png');
                                background-size: cover;

                                @media (max-width: 767px) {
                                    width: calc(100% - 0.75rem);
                                    height: calc(100% - 0.75rem);
                                    border-radius: 0.25rem;
                                }
                            }
                            .flip-qrcode-back {
                                background-image: url('../assets/frame.png');
                                background-size: cover;
                                transform: translate(-50%, -50%) rotateY(180deg);
                                border-radius: 0.25rem;

                                .qrcode {
                                    opacity: 0;
                                    transition: 0.3s;

                                    &.show {
                                        opacity: 1;
                                    }
                                }
                            }
                        }
                    }

                    .quiz-image-container {
                        border-radius: 3%;
                        aspect-ratio: 1 / 1;
                        background-color: var(--legacy-text-color);

                        .quiz-image {
                            background-size: cover;
                            background-repeat: no-repeat;
                            background-position: center;
                        }
                    }
                }
            }
        }
    }

    .footer {
        @media screen and (max-width: 767px) {
            display: none;
        }
    }
}
</style>
